import { render, staticRenderFns } from "./aWorkDetailType.vue?vue&type=template&id=e06e2590&scoped=true"
import script from "./aWorkDetailType.vue?vue&type=script&lang=js"
export * from "./aWorkDetailType.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailType.vue?vue&type=style&index=0&id=e06e2590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e2590",
  null
  
)

export default component.exports